<p-autoComplete
  [placeholder]="placeholder"
  [suggestions]="filteredCustomers"
  (completeMethod)="searchCustomers($event)"
  [(ngModel)]="displayValue"
  [ngModelOptions]="{ standalone: true }"
  [minLength]="minLength"
  [delay]="delay"
  [disabled]="disabled"
  optionLabel="label"
  [forceSelection]="true"
  [showClear]="true"
  [dropdown]="true"
  dropdownMode="current"
  dropdownAriaLabel="Abrir resultados da pesquisa"
  appendTo="body"
  (onSelect)="onSelect($event)"
  (onClear)="onClear()"
  [style]="{ width: '100%' }"
>
  <ng-template let-customer pTemplate="item">
    <div>{{ customer.label }}</div>
  </ng-template>
</p-autoComplete>
